export const INPUT_TAGS = {
  loadScript: 'LOAD_SCRIPT',
  checkLoaded: 'CHECK_LOADED',
} as const;

export type LoadHumanSecurityScriptInput = {
  tag: typeof INPUT_TAGS.loadScript;
  appId: string;
};

export type CheckHumanSecurityLoadedInput = {
  tag: typeof INPUT_TAGS.checkLoaded;
  appId?: string;
};

export type CheckHumanSecurityLoadedOutput = {
  type: 'response';
  _pxvid: string | null | undefined;
  _px3: string | null | undefined;
  _pxcts: string | null | undefined;
  _x_px_cookies: string | null | undefined;
};

export type HumanSecurityInboundPayload =
  | LoadHumanSecurityScriptInput
  | CheckHumanSecurityLoadedInput;

type Event = {
  type: 'event';
  name: string;
  data?: unknown;
};

export type HumanSecurityOutboundPayload =
  | CheckHumanSecurityLoadedOutput
  | Event;
